// Listes des fonctions de tris
    import functions from '@/functions/functions.js'
    import functionsDate from '@/functions/date.js'

    const mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
    const moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');
    const jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
    const jours_fr = new Array('Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche');
    const joursInput = new Array('dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi');
    const heure_numerique = new Array('00', '01', '02', '03', '04', '05', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23')

    // listeElements --> Liste de tous les élements à trier
    // order --> AZ pour croissant ou alphabétique
    // order --> ZA pour décroissant ou alphabétique inversé
    // type --> nom du champs sur lequel on se base pour trier
    // typeDeux --> nom du champs sur lequel on se base pour trier qui est dans un tableau (nom du tableau à indiquer dans type)

    const fonctionsTris = {
        orderBy(listeElements, order, type, id){
            return listeElements.slice().sort((a, b) => {
                return order === 'AZ' ? functions.supprimerCaracteres(a[type], id).toString().localeCompare(functions.supprimerCaracteres(b[type].toString(), id), undefined ,{ numeric: true }) : functions.supprimerCaracteres(b[type], id).toString().localeCompare(functions.supprimerCaracteres(a[type].toString(), id), undefined ,{ numeric: true });
            });
        },

        orderByElement(listeElements, order){
            return listeElements.slice().sort((a, b) => {
                 return order === 'AZ' ? a.localeCompare(b) : b.localeCompare(a);
            });
        },

        orderByDeux(listeElements, order, type, typeDeux) {
            return listeElements.slice().sort((a, b) => {
                return order === 'AZ' ? a[type][typeDeux].toString().localeCompare(b[type][typeDeux].toString(), undefined ,{ numeric: true }) : b[type][typeDeux].toString().localeCompare(a[type][typeDeux].toString(), undefined ,{ numeric: true });
            });
        },

        orderByTrois(listeElements, order, type, typeDeux, typeTrois) {
            return listeElements.slice().sort((a, b) => {
                return order === 'AZ' ? a[type][typeDeux][typeTrois].toString().localeCompare(b[type][typeDeux][typeTrois].toString(), undefined ,{ numeric: true }) : b[type][typeDeux][typeTrois].toString().localeCompare(a[type][typeDeux][typeTrois].toString(), undefined ,{ numeric: true });
            });
        },

        orderByDate(listeElements, order, type) {
            function compare(A, B){
                const a = new Date(A[type].date.year, A[type].date.month - 1, A[type].date.day);
                const b = new Date(B[type].date.year, B[type].date.month - 1, B[type].date.day);

                if(order === 'AZ'){
                    if(a < b) return -1
                    if(a > b) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(a > b) return -1
                    if(a > b) return 1
                    return 0
                }
            }

            return listeElements.slice().sort(compare)
        },
        
        orderByDateDate(listeElements, order) {
            function compare(A, B){
                const a = A.date.replaceAll('-', '')
                const b = B.date.replaceAll('-', '')

                if(order === 'AZ'){
                    if(a < b) return -1
                    if(a > b) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(a > b) return -1
                    if(a > b) return 1
                    return 0
                }
            }

            return listeElements.slice().sort(compare)
        },

        orderByDateDebut(listeElements, order, type){
            console.log(listeElements, order, type)
            function compare(A, B){
                console.log(A, A[type], B, B[type])
                const a = A[type].date_debut.date.replace('-', '')
                const b = B[type].date_debut.date.replace('-', '')

                console.log(a, b)

                if(order === 'AZ'){
                    if(a < b) return -1
                    if(a > b) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(a > b) return -1
                    if(a > b) return 1
                    return 0
                }
            }

            return listeElements.slice().sort(compare)
        },

        orderByDateID(listeElements, order) {
            function compare(A, B){
                const a = new Date(A.date.year, A.date.month - 1, A.date.day);
                const b = new Date(B.date.year, B.date.month - 1, B.date.day);

                if(order === 'AZ'){
                    if(a < b) return -1
                    if(a > b) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(a > b) return -1
                    if(a > b) return 1
                    return 0
                }
            }

            return listeElements.slice().sort(compare)
        },

        trierPlanning(listeElements) {
            let dateActuelle = new Date()
            let jour = jours[dateActuelle.getDay()]
            let heure = dateActuelle.getHours()
            let minute = dateActuelle.getMinutes()
            if(minute < 10){
                minute = '0' + minute
            }
            const triDateActuelle = Number(String(jours_fr.indexOf(jour)) + heure_numerique[heure] + String(minute))
            let planningActuel = []
            let planningApres = []
            let planningAvant = []


            listeElements.forEach(element =>{
                element.heure_arrivee = functionsDate.calculHeureFin(element.jour, element.heure, element.minute, element.duree_fr, '')
                element.tri_depart = Number(String(jours_fr.indexOf(element.jour)) + String(element.heure_fr) + String(element.minute_fr))
                element.tri_arrivee = Number(String(jours_fr.indexOf(element.heure_arrivee.day)) + String(element.heure_arrivee.heure) + String(element.heure_arrivee.minute))
            })

            planningActuel = listeElements.filter(element => {
                if(element.tri_depart <= triDateActuelle && element.tri_arrivee >= triDateActuelle){
                    element.statut = "En vol"
                    return element
                }
            })


            planningApres = listeElements.filter(element => {
                if(element.tri_arrivee > triDateActuelle && triDateActuelle < element.tri_depart || element.tri_arrivee < element.tri_depart && element.tri_depart > triDateActuelle){
                    return element
                }
            })

            planningApres.sort((a, b) => {
                if(a.tri_depart < b.tri_depart) return -1
                if(a.tri_depart > b.tri_depart) return 1
                return 0
            })

            planningAvant = listeElements.filter(element => {
                if(element.tri_arrivee < triDateActuelle && triDateActuelle > element.tri_depart){
                    return element
                }
            })

            planningAvant.sort((a, b) => {
                if(a.tri_depart < b.tri_depart) return -1
                if(a.tri_depart > b.tri_depart) return 1
                return 0
            })

            return planningActuel.concat(planningApres.concat(planningAvant))
        },

        orderNumber(listeElements, order) {
            return listeElements.slice().sort((a, b) => {
                return order === 'AZ' ? Number(a) - Number(b) : Number(b) - Number(a);
            });
        },

        orderNumberType(listeElements, order, type) {
            function compare(a, b){
                if(order === 'AZ'){
                    if(Number(a[type]) < Number(b[type])) return -1
                    if(Number(a[type]) > Number(b[type])) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(Number(a[type]) > Number(b[type])) return -1
                    if(Number(a[type]) < Number(b[type])) return 1
                    return 0
                }
            }
            return listeElements.slice().sort(compare);
        }, 

        orderNumberTypeDeux(listeElements, order, type, typeDeux) {
            function compare(a, b){
                if(order === 'AZ'){
                    if(Number(a[type][typeDeux]) < Number(b[type][typeDeux])) return -1
                    if(Number(a[type][typeDeux]) > Number(b[type][typeDeux])) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(Number(a[type][typeDeux]) > Number(b[type][typeDeux])) return -1
                    if(Number(a[type][typeDeux]) < Number(b[type][typeDeux])) return 1
                    return 0
                }
            }
            return listeElements.slice().sort(compare);
        },

        orderNumberTypeTrois(listeElements, order, type, typeDeux, typeTrois) {
            function compare(a, b){
                if(order === 'AZ'){
                    if(Number(a[type][typeDeux][typeTrois]) < Number(b[type][typeDeux][typeTrois])) return -1
                    if(Number(a[type][typeDeux][typeTrois]) > Number(b[type][typeDeux][typeTrois])) return 1
                    return 0
                }else if(order === 'ZA'){
                    if(Number(a[type][typeDeux][typeTrois]) > Number(b[type][typeDeux][typeTrois])) return -1
                    if(Number(a[type][typeDeux][typeTrois]) < Number(b[type][typeDeux][typeTrois])) return 1
                    return 0
                }
            }
            return listeElements.slice().sort(compare);
        }
    }

    export default fonctionsTris


// WEBPACK FOOTER //
// ./src/functions/tris.js